import { useCallback } from 'react';

import { useAnalyticsUtilities } from '@air/analytics';

import META from '~/hooks/events/useTrackPluginInitialization.meta';

export const useTrackPluginInitialization = () => {
  const { track } = useAnalyticsUtilities();

  const trackPluginInitialization = useCallback(() => {
    track(META.name);
  }, [track]);

  return { trackPluginInitialization };
};
